import React, { useState } from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import Button from '../../baseComponents/gui/button/Button'
import { useModal } from '../../../hooks/useModal'
import { pauseModal } from '../../../constants/copyright-modals'
import { useTranslation } from '../../../translations'
import { gtmFunctions } from '../../../constants/analytics/GTM'
import { getProductCurrentState } from '../../features/product/utils/getProductCurrentState'
import { useContent } from '../../../redux/reducer/content'

const PauseModal = React.forwardRef(function PauseModal({ backFunc, continueFunc }, ref) {
  const { continueText, exitText } = pauseModal
  const { closeModal, id } = useModal()
  const [disabled, setDisabled] = useState(false)
  const { t } = useTranslation()
  const { state } = useContent()
  const { isGameState, gameName } = getProductCurrentState(state)

  return (
    <CustomModal
      className={'custom-modal_pause'}
      animation={['fade', 'scale', 'scale-bounce']}
      styles={'height:'}
      horizontalPosition={''}
    >
      <div
        className={'pause-modal'}
        ref={ref}
      >
        <div className='pause-modal__bg' />
        <div className='pause-modal__content'>
          <h2 className={'pause-modal__title'}>{t('other.pause')}</h2>
          <Button
            disabled={disabled}
            className={`pause-modal__button button_green`}
            onClick={() => {
              setDisabled(true)
              closeModal({ id })
              continueFunc?.()
            }}
          >
            {t(continueText)}
          </Button>
          <Button
            className={`pause-modal__button custom-button_gray`}
            disabled={disabled}
            onClick={() => {
              setDisabled(true)
              closeModal({ id })
              backFunc?.()

              if (isGameState) {
                gtmFunctions.GTMGamesExit({ name: gameName })
              }
            }}
          >
            {t(exitText)}
          </Button>
        </div>
      </div>
    </CustomModal>
  )
})

export default PauseModal
PauseModal.propTypes = {}
